import React, { useState, useEffect } from "react";
import { fetchPublicPlots } from "../services/api";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";
import "react-loading-skeleton/dist/skeleton.css";
import PlotCard from "./PlotCard";

const Plot = () => {
  const [plots, setPlots] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPlots = async () => {
      try {
        const data = await fetchPublicPlots(0, 3); // Get first 3 plots
        setPlots(data.payload.page || []);
      } catch (error) {
        console.error("Error loading plots:", error);
        setPlots([]);
      } finally {
        setLoading(false);
      }
    };

    loadPlots();
  }, []);

  const PlotSkeleton = () => (
    <div className="col-xl-4 col-md-6">
      <div className="project-card style1-1">
        <div className="project-card-details">
          <h4 className="box-title">
            <Skeleton width={200} />
          </h4>
          <Skeleton width={150} height={24} style={{ margin: '10px 0' }} />
          <Skeleton width={120} height={20} style={{ marginBottom: '15px' }} />
          <Skeleton width={100} height={35} style={{ marginTop: "10px" }} />
        </div>
      </div>
    </div>
  );

  return !loading && plots.length <= 0 ? (
    <></>
  ) : (
    <section className="project-sec space-top space-extra-bottom">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-7 col-md-8">
            <div className="title-area text-center">
              <h2 className="sec-title">Available Plots</h2>
            </div>
          </div>
        </div>
        <div className="row gy-4">
          {loading ? (
            [...Array(3)].map((_, index) => <PlotSkeleton key={index} />)
          ) : (
            plots.map((plot) => (
              <PlotCard key={plot.id} plot={plot} />
            ))
          )}
        </div>
        
        {!loading && plots.length > 0 && (
          <div className="row mt-5">
            <div className="col-12 text-center">
              <Link to="/plots" className="th-btn">
                View All Plots <i className="fas fa-arrow-right ms-2"></i>
              </Link>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Plot;
